import { useCurrentHousehold } from '@/hooks/useCurrentHousehold'

/** Diagonal "SAMPLE DATA" across every page while the sample household is current — so a
 *  screenshot of demo numbers can never pass for someone's real finances. Click-through. */
export function SampleWatermark() {
  const { isSample } = useCurrentHousehold()
  if (!isSample) return null
  return (
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-40 flex select-none items-center justify-center overflow-hidden"
      >
        <span className="-rotate-[30deg] whitespace-nowrap font-['Sora',system-ui,sans-serif] text-[clamp(3rem,14vw,11rem)] font-extrabold tracking-widest text-[var(--fl-watermark)]">
          SAMPLE DATA
        </span>
      </div>
      <p className="sr-only" role="status">
        Sample household — not real data
      </p>
    </>
  )
}
